import React from 'react';
import Service from './service';
import PageHeader from '../ui/PageHeader';
import { useLanguage } from "../../i18n/LanguageContext";
import { Box } from '@mui/material';

const ServiceP = () => {
  const { t } = useLanguage();

  return (
    <Box sx={{ bgcolor: '#fff' }}>
      <PageHeader
        title={t('common.services')}
        subtitle={t('contact.subtitle')}
      />
      <Box sx={{ py: { xs: 8, md: 15 } }}>
        <Service hideHeader={true} />
      </Box>
    </Box>
  );
}

export default ServiceP;